export const dark_Theme = {
  bg: "#0B0C1E",
  bgLight: "#1A1E3B",
  bgGradient: "linear-gradient(145deg, #0B0C1E 0%, #1A1E3B 100%)",
  primary: "#6B49F7",
  secondary: "#00E0FF",
  tertiary: "#FF66CC",
  text_primary: "#EAF0F6",
  text_secondary: "#B8C4D6",
  text_tertiary: "#7A8EA8",
  card: "#121630",
  card_light: "#21274F",
  button: "#6B49F7",
  border: "#3F4A7A",
  shadow: "0 4px 15px rgba(0, 224, 255, 0.2)",
  white: "#FFFFFF",
  black: "#000000",
  "--background": "#0f172a",
  "--text": "#f1f5f9",
};

export const light_Theme = {
  bg: "#F2F7FF",
  bgLight: "#E6EFFB",
  bgGradient: "linear-gradient(145deg, #F2F7FF 0%, #E6EFFB 100%)",

  primary: "#6B49F7",
  secondary: "#00E0FF",
  tertiary: "#FF66CC",

  text_primary: "#1A233D",
  text_secondary: "#5E6C84",
  text_tertiary: "#9AA8BE",

  card: "#F5F8FE",
  card_light: "#EBF1FB",
  button: "#6B49F7",
  border: "#CED8EA",
  shadow: "0 4px 15px rgba(0, 0, 0, 0.08)",
  white: "#FFFFFF",
  black: "#000000",
};
